import {
	Checkbox,
	Dimmer,
	Divider,
	Header,
	Label,
	Loader,
	Message,
	Segment,
} from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import type { Bureau } from '../../../interfaces/bureaux';
import type Collectivite from '../../../interfaces/collectivite';

interface CollectivitesSegmentProps {
	bureaux: { [key: string]: Bureau[] };
	isBureauxLoading: boolean;
	collectivites: Collectivite[];
	onSelectBureau: (bureau: Bureau) => void;
	onSelectCollectivite: (idE: string, checked: boolean) => void;
	newUserCollectivites: Collectivite[];
	error: boolean;
}

const CollectivitesSegment = ({
	bureaux,
	isBureauxLoading,
	onSelectBureau,
	collectivites,
	onSelectCollectivite,
	newUserCollectivites,
	error,
}: CollectivitesSegmentProps) => {
	const handleSelectCollectivite = (idE: string, checked: boolean) => {
		onSelectCollectivite?.(idE, checked);
	};

	return (
		<Segment basic className="collectivite-segment">
			<Header textAlign="left" as="h4">
				Veuillez sélectionner des collectivités et des bureaux associés pour le
				parapheur de l&apos;utilisateur
			</Header>
			{isBureauxLoading ? (
				<Segment basic>
					<Dimmer active inverted>
						<Loader>Chargement des bureaux...</Loader>
					</Dimmer>
				</Segment>
			) : (
				<>
					{error && (
						<Message
							error
							content="Veuillez sélectionner au moins une collectivité."
						/>
					)}
					{collectivites.map((collectivite) => {
						const selected = newUserCollectivites.some(
							(uc) => uc.id_e === collectivite.id_e,
						);

						return (
							<Segment key={collectivite.id_e}>
								<Checkbox
									label={collectivite.libelle}
									onChange={(_e, { checked }) =>
										handleSelectCollectivite(collectivite.id_e, !!checked)
									}
									checked={selected}
								/>
								{selected && (
									<Icon
										name="checkmark"
										color="green"
										size="large"
										className="collectivite-icon"
									/>
								)}
								<Divider hidden />
								<p>
									{selected
										? 'Veuillez sélectionner un ou plusieurs bureaux pour sélectionner cette collectivité.'
										: 'Veuillez cocher la commune pour pouvoir sélectionner un bureau.'}
								</p>

								{bureaux[collectivite.id_e]?.map((bureau) => (
									<Label
										key={bureau.id}
										className="bureau-user"
										circular
										basic
										onClick={() =>
											selected ? onSelectBureau(bureau) : undefined
										}
										color={selected && bureau.isSelected ? 'blue' : 'grey'}
										style={{
											cursor: `${selected ? 'pointer' : 'not-allowed'}`,
										}}
									>
										{bureau.name}
									</Label>
								))}
							</Segment>
						);
					})}
				</>
			)}
		</Segment>
	);
};

export default CollectivitesSegment;
